module.exports = __webpack_public_path__ + "img/github.04c04afd.svg";